import Switch from "@mui/material/Switch";
import axios from "axios";
import { useEffect, useState } from "react";
import { store } from "static";

interface SwitchButtonProps {
  defaultValue: boolean;
  URL: string;
  row?: any;
  fetchData?: (force_refresh: boolean) => void;
  disabled?: boolean;
}

export const SwitchButton = (props: SwitchButtonProps) => {
  const handleSwitchChange = async (event: React.ChangeEvent<HTMLInputElement>) => {
    let paylod = {
      JWT: store.user.JWT,
      data: {
        ...props.row,
        enabled: event.target.checked,
      },
    };
    await axios.post(props.URL, paylod);
    const status = event.target.checked ? "Enabled" : "Disabled";
    store.Alert(`Doc ${props?.row?.alias}  ${status}`, "success");
    setTimeout(() => {
      props.fetchData && props.fetchData(true);
    }, 1000);
  };
  return <Switch defaultChecked={props.defaultValue} onChange={handleSwitchChange} disabled={props.disabled} />;
};
